<template>
 <swiper :options="swiperOption" ref="mySwiper">
    <!-- slides -->
    <swiper-slide>
        <div class="swiper_item">
            <div>
                <h4>园区级物业管理</h4>
                <p>INDUSTRIAL PARK MANAGEMENT</p>
                <div>
                    <img src="../assets/b_2.png" alt="">
                </div>
                <p>园区服务运营解决方案旨在为园区提供面向企业和企业员工的服务运营信息化平台</p>
            </div>
        </div>
    </swiper-slide>
    <swiper-slide>
        <div class="swiper_item">
            <div>
                <h4>楼宇资产管理</h4>
                <p>PROPERTY MANAGEMENT</p>
                <div>
                    <img src="../assets/b_1.png" alt="">
                </div>
                <p>在业务串联与流程上与现有系统打通，将经营管理颗粒度下层到房间和工位，满足不同市场需求</p>
            </div>
        </div>
    </swiper-slide>
    <swiper-slide>
        <div class="swiper_item">
            <div>
                <h4>运营商企业楼层管理</h4>
                <p>OPERATION MANAGEMENT</p>
                <div>
                    <img src="../assets/b_3.png" alt="">
                </div>
                <p>深入业务对空间经营进行全方位的定制化管理，将原本空间与人的关系联系得更加紧密</p>
            </div>
        </div>
    </swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-pagination"  slot="pagination" style="bottom:0;"></div>
    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div> -->
    <!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
  </swiper>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "carrousel",
  data() {
    return {
      swiperOption: {
        // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
        // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // swiper configs 所有的配置同swiper官方api配置
        speed: 400,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        direction: "horizontal",
        // effect: "cube",
        // grabCursor: true,
        // setWrapperSize: true,
        // autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许点击小圆点跳转
        },
        // paginationType: "bullets",
        // pagination: ".swiper-pagination",
        // paginationClickable: true,
        // prevButton: "null",
        // nextButton: "null",
        // scrollbar: ".swiper-scrollbar",
        // mousewheelControl: true,
        observeParents: true
        // if you need use plugins in the swiper, you can config in here like this
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        // debugger: true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        // onTransitionStart(swiper){
        //   console.log(swiper)
        // },
        // more Swiper configs and callbacks...
        // ...
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  // you can find current swiper instance object like this, while the notNextTick property value must be true
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false);
  }
};
</script>
<style scoped>
.swiper_item {
  margin: 20px;
  border: 1px solid #dcdcdc;
  background-color: #fff;
}
.swiper_item > div {
  padding: 15px;
  text-align: left;
}
.swiper_item > div > h4 {
  font-size: 19px;
  color: #707070;
  margin-bottom: 5px;
}
.swiper_item > div > p:nth-child(2) {
  font-size: 12px;
  color: #b8b8b8;
  margin-bottom: 5px;
}
.swiper_item > div > div {
  display: flex;
  align-items: center;
}
.swiper_item > div > div > img {
  height: 130px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.swiper_item > div > p:nth-child(4) {
  font-size: 12px;
  color: #707070;
}
</style>
